import { DEPRECATED_GADGETS_MAP } from '../constants.tsx';

export const isDeprecatedGadget = (gadgetResource?: string): boolean => {
	return (
		gadgetResource !== undefined &&
		(gadgetResource in DEPRECATED_GADGETS_MAP ||
			Object.values(DEPRECATED_GADGETS_MAP).includes(gadgetResource))
	);
};
